import { types } from 'mobx-state-tree';
import { Battery } from 'src/types/commons/products';
import { logRejectedModel } from 'src/utils/logger';
import { BatteryModel } from './types/ProductTypes';

const BatteriesStore = types
    .model('BatteriesListStore', {
        batteries: types.optional(types.map(BatteryModel), {}),
    })
    .actions(self => ({
        setBatteries: (batteries: Battery[]) => {
            self.batteries.clear();
            batteries.forEach(battery => {
                if (BatteryModel.is(battery)) {
                    self.batteries.set(battery.id, battery);
                } else {
                    logRejectedModel(BatteryModel.name, battery);
                }
            });
        },
    }));

export default BatteriesStore;
